module.exports = __webpack_public_path__ + "static/media/building.6e309639.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/images/building.jpg
// module id = 423
// module chunks = 0